module.exports = __webpack_public_path__ + "static/media/WHEELS.da08d628.png";